<template>
  <div class="buttons has-addons are-large mb-6">
    <button
      type="button"
      class="button is-status"
      v-for="s in statusWiseRecords"
      @click="updateStatus(s.value)"
      :disabled="appStore.articleStateCounter !== 0"
      :key="s.value"
      :id="`btn-status-${s.value}`"
      :class="{ 'is-link is-selected': s.value === selectedStatus, 'is-loading': isLoading }">
      <animated-integer v-if="!isLoading" :id="`status-${s.value}-number`" class="has-text-link" :value="s.count" />
      <br />
      <span class="is-size-6">{{ s.name }}</span>
    </button>
  </div>
</template>

<script>
import { AnimatedInteger } from '@/components/shared';
import { useAppStore } from '@/store/modules/app';
import { useMarinLitSearchStore } from '@/store/modules/marinlit/search';
import { useMerckIndexSearchStore } from '@/store/modules/merckindex/search';

export default {
  name: 'StatusLinks',
  setup() {
    const appStore = useAppStore();
    const marinLitSearchStore = useMarinLitSearchStore();
    const merckIndexSearchStore = useMerckIndexSearchStore();

    return {
      appStore,
      marinLitSearchStore,
      merckIndexSearchStore,
    };
  },
  props: {
    statusWiseRecords: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    isLoading() {
      return this.statusWiseRecords.every(obj => !Object.keys(obj).length);
    },
    selectedStatus() {
      // Get the selected status from the current product's store
      return this[`Status${this.$route.name}`];
    },
    StatusMerckIndex: {
      get() {
        return this.merckIndexSearchStore.SearchParams.status.value;
      },
      set(value) {
        this.merckIndexSearchStore.updateField({
          path: 'SearchParams.status.value',
          value
        });
      }
    },
    StatusMarinLit: {
      get() {
        return this.marinLitSearchStore.SearchParams.status.value;
      },
      set(value) {
        this.marinLitSearchStore.updateField({
          path: 'SearchParams.status.value',
          value
        });
      }
    },
  },
  methods: {
    updateStatus(status) {
      // Set the selected status in the current product's store
      this[`Status${this.$route.name}`] = status;
      this.$emit('click', true);
    },
  }, 
  components: {
    AnimatedInteger,
  },
}
</script>

<style lang="scss" scoped>
button.is-status {
  margin: 0;
  padding: 0;
  height: 3em;
  flex-grow: 1;
  flex-basis: 0;
  display: block;
  line-height: 1.05;
  &.is-selected span {
    color: white !important;
  }
}
</style>